module.exports = __webpack_public_path__ + "img/ico_list_tile.42188088.svg";